import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import repair from './modules/repair'
import service from './modules/service'
import diagnoses from './modules/diagnoses'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    repair,
    service,
    diagnoses
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js